import React, { useState } from 'react';
import { Badge, Dropdown, List, Button, Spin } from 'antd';
import { BellOutlined } from '@ant-design/icons';

import { useNotifications } from '@portal/hooks/useNotifications';
import { translate } from '@portal/services/i18n';
import { ZONE } from '@portal/utils/format';
import './NotificationWidget.less';
import { DateTime } from 'luxon';
import { useNavigation } from '@portal/hooks/useNavigation';

interface Notification {
  id: string;
  sentAt?: string;
  notification?: {
    title?: string;
    message?: string;
  };
}

const NotificationWidget = () => {
  const navigate = useNavigation();
  const { notifications, loading, unreadCount } = useNotifications();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleViewAll = () => {
    setDropdownVisible(false);
    navigate('/notificacoes');
  };

  const notificationItems =
    notifications?.slice(0, 5).map((item: Notification) => ({
      key: item.id,
      title:
        item.notification?.title || translate('PAGES.NOTIFICATIONS.NO_TITLE'),
      description:
        item.notification?.message ||
        translate('PAGES.NOTIFICATIONS.NO_DESCRIPTION'),
      time: item.sentAt
        ? DateTime.fromISO(item.sentAt).toFormat('dd/MM/yyyy HH:mm', {
            timeZone: ZONE,
          })
        : '-',
    })) || [];

  const dropdownContent = (
    <div className="notification-widget__dropdown">
      <div className="notification-widget__header">
        <strong>{translate('PAGES.NOTIFICATIONS.RECENT')}</strong>
        <Button type="link" size="small" onClick={handleViewAll}>
          {translate('PAGES.NOTIFICATIONS.VIEW_ALL')}
        </Button>
      </div>

      {loading ? (
        <div className="notification-widget__loading">
          <Spin size="small" />
        </div>
      ) : notificationItems.length > 0 ? (
        <List
          size="small"
          dataSource={notificationItems}
          className="notification-widget__list"
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={item.title}
                description={
                  <div>
                    <div className="notification-widget__description">
                      {item.description.length > 60
                        ? `${item.description.substring(0, 60)}...`
                        : item.description}
                    </div>
                    <div className="notification-widget__time">{item.time}</div>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      ) : (
        <div className="notification-widget__empty">
          {translate('PAGES.NOTIFICATIONS.NO_NOTIFICATIONS')}
        </div>
      )}
    </div>
  );

  return (
    <Dropdown
      overlay={dropdownContent}
      trigger={['click']}
      open={dropdownVisible}
      onOpenChange={setDropdownVisible}
      placement="bottomRight"
    >
      <div className="notification-widget__trigger">
        <Badge count={unreadCount} size="small">
          <BellOutlined />
        </Badge>
      </div>
    </Dropdown>
  );
};

export default NotificationWidget;
